import Vue from 'vue'
import App from './App.vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

Vue.component('multiselect', Multiselect)

Vue.config.productionTip = false

let router = new VueRouter({
  mode: 'history',
  routes: [],
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')


if (process.env.NODE_ENV === 'production') {
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments)
    }
    i[r].l = 1 * new Date()
    a = s.createElement(o)
    m = s.getElementsByTagName(o)[0]
    a.async = 1
    a.src = g
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga')
  // eslint-disable-next-line
  ga('create', 'UA-5355512-14', 'auto')
  // eslint-disable-next-line
  ga('send', 'pageview')
}

